import { render, staticRenderFns } from "./PublishAchievement.vue?vue&type=template&id=bcce7084&scoped=true"
import script from "./PublishAchievement.vue?vue&type=script&lang=js"
export * from "./PublishAchievement.vue?vue&type=script&lang=js"
import style0 from "./PublishAchievement.vue?vue&type=style&index=0&id=bcce7084&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcce7084",
  null
  
)

export default component.exports